module.exports = __webpack_public_path__ + "static/Ricc Alphabet-22070f9b789ee850e6a54c0f1399ad34.mp4";